import { getCateGroyList } from '@/api/module'

const state = {
  Navigation: {},
  load: false
}

const mutations = {
  SET_CATE: (state, cate) => {
    state.Navigation = cate
  }
}

const actions = {
  getCateGroyList ({commit, state}) {
    return new Promise((resolve, reject) => {
      if (state.load) { resolve(state.Navigation) } else {
        getCateGroyList().then(res => {
          const { data } = res
          commit('SET_CATE', data.items)
          state.load = true
          resolve(data.items)
        }).catch(res => {
          reject(res)
        })
      }
    })
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js